import { HttpClient } from '@angular/common/http';
import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Observable, of } from 'rxjs';
import {
  PaymentExecutionV1Request,
  PaymentExecutionV1Response,
  PaymentInquiryV1Response,
  PaymentPreviewHostedPaymentV1Request,
  PaymentPreviewHostedPaymentV1Response,
  PaymentPreviewV1Response,
  PayOnAccountPaymentPreviewV1Response,
} from '../models';
import { PaymentInformationService } from './payment-information.service';

/* istanbul ignore next */
export class PaymentInformationGuestCheckoutService extends PaymentInformationService {
  constructor(
    private httpClient: HttpClient,
    protected appConfig: AppConfigSettings,
  ) {
    super(appConfig);
  }

  updateHostedPaymentPreviewV1(
    tenantId: string,
    paymentPreviewHostedPaymentV1Request: PaymentPreviewHostedPaymentV1Request,
  ): Observable<PaymentPreviewHostedPaymentV1Response> {
    return this.httpClient.put<PaymentPreviewHostedPaymentV1Response>(
      `${this.baseUrl}/v1/tenants/${tenantId}/payment/hosted-payments/preview`,
      paymentPreviewHostedPaymentV1Request,
    );
  }

  updatePaymentPreviewV1() {
    return of();
  }

  getHostedPaymentPreviewV1(
    tenantId: string,
    paymentReference: string,
  ): Observable<PaymentPreviewHostedPaymentV1Response> {
    return this.httpClient.get<PaymentPreviewHostedPaymentV1Response>(
      `${this.baseUrl}/v1/tenants/${tenantId}/payment/hosted-payments/preview/paymentreference/${paymentReference}`,
    );
  }

  getPaymentPreviewV1(): Observable<PaymentPreviewV1Response> {
    return of(null);
  }

  getPayOnAccountPaymentPreviewV1(): Observable<PayOnAccountPaymentPreviewV1Response> {
    return of(null);
  }

  executePaymentV1(
    tenantId: string,
    paymentReference: string,
    transactionReference: string,
    paymentExecutionV1Request: PaymentExecutionV1Request,
  ): Observable<PaymentExecutionV1Response> {
    return this.httpClient.post<PaymentExecutionV1Response>(
      `${this.baseUrl}/v1/tenants/${tenantId}/payment/execution/hosted-payments/paymentreference/${paymentReference}/transactionreference/${transactionReference}`,
      paymentExecutionV1Request,
    );
  }

  getBuyerAccountsV1() {
    return of();
  }

  GetPayOtherDocuments() {
    return of();
  }

  updatePaymentPreviewPayOnAccountV1() {
    return of();
  }

  getPaymentByReferenceV1(tenant: string, paymentReference: string) {
    return this.httpClient.get<PaymentInquiryV1Response>(
      `${this.baseUrl}/v1/tenants/${tenant}/hosted-payments/paymentinquiry/paymentreference/${paymentReference}`,
    );
  }
}
